export let arrayUtils = {};

arrayUtils.intersection = function (a,b) {
//supposedly Set.has is 10x faster than Array.includes or Array.indexOf
//This will return the unique intersection
    const seta = new Set(a);
    const setb = new Set(b);
    return [...seta].filter(num => setb.has(num));
};

arrayUtils.difference = function (lhs,rhs) {
//supposedly Set.has is 10x faster than Array.includes or Array.indexOf
//This will return the unique intersection
    const setLhs = new Set(lhs);
    const setRhs = new Set(rhs);
    let left = [...setLhs].filter(num => !setRhs.has(num));
    let right = [...setRhs].filter(num => !setLhs.has(num));

    let diff;
    if (left.length || right.length) diff = {};
    if (left.length) diff.left = left;
    if (right.length) diff.right = right;
    return diff;
};

//If we ever need deep difference then we can install lodash/array and lodash/lang and install
/*
arrayUtils.deepDifference = function (lhs,rhs) {
//Use lodash to do this for deep comparing values like objects
    const lodashArray = require('lodash/array');
    const lodashLang = require('lodash/lang');

    let left = lodashArray.differenceWith(lhs, rhs, lodashLang.isEqual);
    let right = lodashArray.differenceWith(rhs, lhs, lodashLang.isEqual);

    let diff;
    if (left.length || right.length) diff = {};
    if (left.length) diff.left = left;
    if (right.length) diff.right = right;
    return diff;
};
*/

arrayUtils.union = function (a,b,unique) {
    const seta = new Set(a);
    if (unique) {
        for (let item of b) {
            seta.add(item)
        }
        return [...seta]
    } else {
        const setb = new Set(b);
        return [...seta,...setb];
    }
};

arrayUtils.pushUnique = function (a,value) {
    let s = new Set(a);
    s.add(value);
    return [ ...s ];
};

//this to make it easier to push one array to an existing array
//useful if you don't want to use concat because it creates new array
arrayUtils.pushArray = function (a,values,unique) {
    for (let item of values) {
        if (unique && a.includes(item)) continue;
        a.push(item);
    }
};

arrayUtils.unique = function (a) {
    return [ ...new Set(a) ];
};

arrayUtils.max = function (a) {
    return Math.max(...a);
};

arrayUtils.min = function (a) {
    return Math.min(...a);
};

arrayUtils.sum = function (a) {
    return a.reduce((x,acc)=>acc+x,0);
};

arrayUtils.avg = function (a) {
    return this.sum(a)/a.length;
};

